import { queryOptions } from "@tanstack/react-query";
import { client, handleClientMethod } from "../client.ts";

export const getCustomParts = () => {
  return queryOptions({
    queryKey: ["/api/custom-parts"],
    queryFn: async () => {
      return await handleClientMethod(client.GET("/api/custom-parts", {}));
    },
  });
};
